import React from "react";
import Link from "gatsby-link";
import Chilling from "../images/trucks.jpg";

const IndexPage = () => (
  <div className="text-center">
    <img src={Chilling} className="block mx-auto" />
    <h2 className="bg-yellow inline-block my-8 p-3">
      Gather Metrics. Report. Analyze.
    </h2>
    <p className="leading-loose">
      Simplify your fleet reporting!
    </p>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js